// extracted by mini-css-extract-plugin
module.exports = {"centerContent":"GridCenterContent_centerContent__0iz__"};